<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div class="modal-custom" v-show="showOverlay">
            <div class="loader-img-center">
              <i class="fa fa-spinner fa-spin"></i> Please wait...
            </div>
          </div>
          <div>
            <h3 class="d-inline heading">Admin Console</h3>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>
          <div class="mentor-container">
            <b-alert
              :show="dismissCountDown"
              dismissible
              variant="success"
              @dismissed="dismissCountDown=0"
              @dismiss-count-down="countDownChanged"
              >
              {{ success_message }}
            </b-alert>
            <div class="row db-row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5  float-left" >

                    <div class="db-card">
                      <div class="col-12 p-0">
                        <h5 class="title">My Account</h5>
                      </div>
                      <div class="col-12 p-0">
                        <p class="mb-2"><span class="acc-info">Account Name: </span>{{ accountItems.account_name }}</p>
                        <p class="mb-0"><span class="acc-info">Address: </span>{{ accountItems.account_address }}</p>
                        <p class="mb-0"><span class="acc-info">City: </span>{{ accountItems.account_city }}</p>
                        <p class="mb-0"><span class="acc-info">State/Province: </span>{{ accountItems.account_state }}</p>
                        <p class="mb-0"><span class="acc-info">Zip Code: </span>{{ accountItems.account_zip }}</p>
                        <p class="mt-2"><span class="acc-info">Phone Number: </span>{{ accountItems.account_phoneno }}</p>
                      </div>
                    </div>
                    <div class="db-card">
                      <div class="col-3 p-0 float-left">
                        <h5 class="title">My Licenses</h5>
                      </div>
                      <div class="col-9 p-0 float-right" style="text-align: right;">
                        <router-link to="manage-license" style="float:right;">
                          <button type="submit" class="btn btn-md ma-blue-btn" @click="openAddLicenseModal">Add Licenses</button>
                        </router-link>
                        <router-link to="add-mentee" style="float:right; padding-right: 10px; padding-top: 6px;" v-if="accountItems.program == 'Mentorship' || accountItems.program == 'Mentorship & Apprenticeship'">
                          <button type="submit" class="btn btn-primary btn-sm dbAddBtn" style="text-decoration: none !important;">Add Mentee</button>
                        </router-link>
                        <router-link to="add-apprentice" style="float:right; padding-right: 10px; padding-top: 6px;" v-if="accountItems.program == 'Apprenticeship' || accountItems.program == 'Mentorship & Apprenticeship'">
                          <button type="submit" class="btn btn-primary btn-sm dbAddBtn" style="width: 130px; text-decoration: none !important;">Add Apprentice</button>
                        </router-link>
                      </div>
                      <div style="clear: both;"></div>
                      <div class="col-12 p-0" v-if="accountItems">
                        <div class="col-12 license-count" style="margin-bottom: 0;">
                          {{ accountItems.account_has_license }} Available License(s)
                          <div class="col-12 p-0" v-if="accountItems.account_reassign_license.length > 0">
                            <div class="col-12 license-count p-0" style="margin: 0;" v-if="accountItems.account_reassign_license.length == 1">
                              {{ accountItems.account_reassign_license.length }} Reassignable License(s) { {{ accountItems.account_reassign_license[0].remaining_days }} Days Remaining }
                            </div>
                            <div class="col-12 license-count p-0" style="margin: 0;" v-if="accountItems.account_reassign_license.length > 1">
                              {{ accountItems.account_reassign_license.length }} Reassignable License(s) 
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 p-0">


                        <div class="db-report-card" v-for="(item, index) in menteesApprentices" :key="index">
                            <div class="row">
                                <div class="col-7 db_name_block">
                                    <div class="col-2 p-0"  style="cursor:pointer; float: left; margin-right: 0px;" @click="getMenteeProfileLink(item.id)">
                                      <avatar :username="item.initials" :customStyle="customStyle" :lighten="100" color="#FFF"></avatar>
                                    </div>
                                    <div class="db-mentee-name">{{item.first_name + ' ' + item.last_name}}</div>
                                    <div class="db-mentee-email">
                                      {{ item.email }}
                                    </div>
                                </div>
                                <div class="col-3" :class="item.licenseExpireTextClass" >
                                  {{ item.licenseExpireText }}
                                </div>
                                <div class="col-2 renew-flag" v-if="item.assignFlag == 1" @click="assignLicense(item.id)">
                                  Assign License
                                </div>
                                <div class="col-2 renew-flag" v-else-if="item.renewFlag == 1" @click="renewLicense(item.id)">
                                  Renew License
                                </div>
                                <div class="col-2" style="text-align: right; padding-right: 10px;" v-else-if="item.inactiveFlag == 1" @click="inactiveLicense(item.id)">
                                  <i class="cursor-pointer fa fa-ban" style="font-size: 21px; color: #FF0000; padding-left: 5px; padding-top: 18px; font-weight: normal;"></i>
                                </div>
                            </div>
                        </div>





                       </div>  
                    </div>
                    <div class="db-card">
                      <div class="col-12 p-0">
                        <h5 class="title">My Pending Mentors</h5>
                      </div>
                      <div class="col-12 p-0">
                      </div>

                      <div class="col-12 p-0">


                        <div class="db-report-card" v-for="(item, index) in pendingMentors" :key="index">
                            <div class="row">
                               <div class="col-7 db_name_block">
                                    <div class="col-2 p-0"  style="cursor:pointer; float: left; margin-right: 0px;" @click="getMenteeProfileLink(item.id)">
                                      <avatar :username="item.initials" :customStyle="customStyle" :lighten="100" color="#FFF"></avatar>
                                    </div>
                                    <div class="db-mentee-name">{{item.first_name + ' ' + item.last_name}}</div>
                                    <div class="db-mentee-email">
                                      {{ item.email }}
                                    </div>
                                </div>
                                <div class="col-5" style="padding-top: 10px; text-align: right; padding-left: 5px;">
                                  <div v-if="item.resendAssessmentCount == 1" class="col-4 p-0 renew-flag float-left" style="cursor: pointer;" @click="resendMentorAssessmentAction(item.resendAssessmentLists[0])">
                                    Resend
                                  </div>
                                  <div v-if="item.resendAssessmentCount > 1" class="col-4 p-0 renew-flag float-left" style="cursor: pointer;" @click="openResendAssessmentModal(item.resendAssessmentLists)">
                                    Resend
                                  </div>
                                  <div v-if="item.assessmentCompleteCount == 1" class="col-4 p-0 renew-flag float-left" style="cursor: pointer;" @click="viewMentorAssessmenteport(item.completedAssessmentAttemptId)">
                                    View
                                  </div>
                                  <div v-if="item.assessmentCompleteCount > 1" class="col-4 p-0 renew-flag float-left" style="cursor: pointer;" @click="openViewAssessmentModal(item.id)">
                                    View
                                  </div>
                                  <div @click="addMentor(item)"
                                  v-if="item.completedFlag == true" class="col-4 p-0 renew-flag float-left" style="cursor: pointer;">
                                    Add Mentor
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 p-0" v-if="pendingMentors.length == 0">
                          <div class="db-report-card" style="font-style: italic; font-weight: bold;font-size: 13px; text-align: center;" >
                              No Pending Mentors
                          </div>
                        </div>

                      </div>                     
                     </div>  
                                   

                  <db-card-list
                      card_title="My Managers"
                      btnName="Add Manager"
                      btnLink="add-manager"
                      btnType="edit"
                      isListType="manager"
                      :count="managerCount" 
                      :itemLength="managerItems.length" 
                      :allItems="managerItems"
         
                      tab_name="managers">
                  </db-card-list>



                </div>    

                <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 float-left p-0" style="margin-right: 0px; max-width: 55%;">
                    <div class="db-card">
                      <div class="col-12 p-0">
                        <h5 class="title">Purchase History</h5>
                      </div>
                      <div class="col-12 p-0">
                        <div class="receipt-heading-1 receipt-heading">
                          Date
                        </div>
                        <div class="receipt-heading-2 receipt-heading">
                          Orders
                        </div>
                        <div class="receipt-heading-3 receipt-heading">
                          Quantity
                        </div>
                        <div class="receipt-heading-4 receipt-heading">
                          Total
                        </div>
                        <div class="receipt-heading-5 receipt-heading">
                          Purchase Type
                        </div>
                        <div class="receipt-heading-6 receipt-heading text-center">
                          Status
                        </div>
                      </div>
                      <div v-if="orderItems.length> 0">
                      <div class="col-12 p-0" v-for="(order, index) in orderItems">
                        <div class="receipt-heading-1 receipt">
                          {{ order.date }}
                        </div>
                        <div class="receipt-heading-2 receipt">
                          <a href="javascript:void(0);" class="invoice_link" @click="getInvoicePdf(order)">{{ order.invoiceNo }}</a>
                        </div>
                        <div class="receipt-heading-3 receipt">
                          {{ order.noOfUnits }} Licenses
                        </div>
                        <div class="receipt-heading-4 receipt">
                          &#36;{{ order.totalAmount }} 
                        </div>
                        <div class="receipt-heading-5 receipt">
                          {{ order.paymentType }}
                        </div>
                        <div class="receipt-heading-6 receipt text-center" v-if="order.paymentStatus != 'Due'">
                          {{ order.paymentStatus }}
                        </div>
                        <div v-else-if="(($store.state.roles.indexOf('ROLE_BILLING_ADMIN') > -1) || ($store.state.roles.indexOf('ROLE_PRIMARY_ADMIN') > -1))" class="receipt-heading-6 receipt">
                          <button style="font-size: 10px;" type="submit" class="btn btn-md ma-blue-btn" @click="openProcessPaymentModal(order.orderId)">Process Payment</button>
                        </div>
                        <div class="receipt-heading-6 receipt text-center" v-else>
                          {{ order.paymentStatus }}
                        </div>
                        <div style="clear: both;"></div>
                      </div>
                      </div>
                      <div v-if="orderItems.length == 0">
                        <div class="col-12 p-0 receipt">
                          No Orders Found.
                        </div>
                      </div>
                      <div style="clear: both; margin-bottom: 30px;"></div>
                    </div>
                    
                </div>
                </div>

            </div>
          </div>
        </div>
      </div>
      <AssignLicense
        :isModalVisible="isAssignModalVisible"
        :license_expire_date="license_expire_date"
        :license_account_id="license_account_id"
        :hasLicense="hasLicense"
        :assignModalTitle="assignModalTitle"
        :menteeName="menteeName"
        :menteeId="menteeId"
        :reassignLicenseFlag="reassignLicenseFlag"
        :reassignLicenseOptions="reassignLicenseOptions"
        ref="AssignModal"
        @close="isAssignModalVisible = false">
      </AssignLicense> 
      <RenewLicense
        :isModalVisible="isRenewModalVisible"
        :license_expire_date="license_expire_date"
        :license_account_id="license_account_id"
        :hasLicense="hasLicense"
        :assignModalTitle="assignModalTitle"
        :menteeName="menteeName"
        :menteeId="menteeId"
        :reassignLicenseFlag="reassignLicenseFlag"
        :reassignLicenseOptions="reassignLicenseOptions"
        ref="RenewModal"
        @close="isRenewModalVisible = false">
      </RenewLicense> 
      <InactiveLicense
        :isModalVisible="isInactiveModalVisible"
        :menteeName="menteeName"
        :menteeId="menteeId"
        :reassign_license_duration="reassign_license_duration"
        ref="InactiveModal"
        @close="isInactiveModalVisible = false">
      </InactiveLicense>

      <AddLicense
        :isModalVisible="isAddLicenseModalVisible"
        ref="AddLicenseModal"
        :totalLicense = "accountItems.account_has_license" 
        @close="isAddLicenseModalVisible = false">
      </AddLicense>

      <ProcessPayment
        :isModalVisible="isProcessPaymentModalVisible"
        ref="ProcessPaymentModal"
        @close="isProcessPaymentModalVisible = false">
      </ProcessPayment>

      <ViewMultipleCompletedAssessment :isModalVisible="isModalVisible" @close="isModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading"><h3>View Assessments</h3></div>
        <div slot="body">
          <div class="col-11 override-padding" style="display:block; padding-top: 20px; !important" v-for="(item1, index) in multipleCompletedAssessment" :key="index">
            <div class="col-7 p-0 float-left" style="padding-top: 30px !important;">
              <b>{{ item1.assessmentName}}</b>
            </div>
            <div class="col-5 p-0 float-right" style="padding-top: 20px !important; text-align: right;">
            <button class="btn btn-md ma-blue-btn" style="width: 150px; height: 35px;" @click="viewMentorAssessmenteportModal(item1.completedAssessmentAttemptId)">Select</button>
            </div>
          </div>
          <div style="clear: both; margin-bottom: 20px;"></div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </ViewMultipleCompletedAssessment>



      <ResendAssessment :isModalVisible="isResendAssessmentModalVisible" @close="isResendAssessmentModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading"><h3>Resend Assessments</h3></div>
        <div slot="body">
          <div class="col-11 override-padding" style="display:block; padding-top: 20px; !important" v-for="(item1, index) in multipleResendAssessment" :key="index">
            <div class="col-7 p-0 float-left" style="padding-top: 30px !important;">
              <b>{{ item1.assessmentName}}</b>
            </div>
            <div class="col-5 p-0 float-right" style="padding-top: 20px !important; text-align: right;">
            <button class="btn btn-md ma-blue-btn" style="width: 150px; height: 35px;" @click="resendAssessmentFromModal(item1.sendMentorAssessmentId)">Select</button>
            </div>
          </div>
          <div style="clear: both; margin-bottom: 20px;"></div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </ResendAssessment>





      <ActivateModal :isModalVisible="isAddMentorModalVisible"   @close="isAddMentorModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Add Mentor</div>
        <div slot="body">
          <div style="font-weight: bold; font-size: 13px; color: #002F42;">Are you sure you want to add {{ selectedMentorName }} as a mentor?</div>
        </div>
        <div slot="footer" class="col-4 p-0">
            <button class="left col-12 btn btn-red" @click="addMentorAction()" style="border-radius: 0px;">Add Mentor</button>
        </div>
      </ActivateModal>


    </div>

  </div>
</template>

<script>
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import AssignLicense from './assign_license_modal.vue';
import RenewLicense from './renew_license_modal.vue';
import InactiveLicense from './inactive_license_modal.vue';
import AddLicense from './add_license.vue';
import ProcessPayment from './process_payment.vue';
import ViewMultipleCompletedAssessment from '../admin/create-tasklist-modal.vue';
import ResendAssessment from '../admin/create-tasklist-modal.vue';
import ActivateModal from '../shared/delete_modal_alert.vue';
import Avatar from 'vue-avatar';
import DbCardList from './db_card_list.vue';

export default {
    data: function () {
        return {
            loading: false,
            accountItems: [],
            menteesApprentices: [],
            pendingMentors: [],
            isAssignModalVisible: false,
            isRenewModalVisible: false,
            isInactiveModalVisible: false,
            isAddLicenseModalVisible: false,
            showOverlay: false,
            license_expire_date: '',
            license_account_id: '',
            hasLicense: '',
            assignModalTitle: 'Activate User',
            menteeName: '',
            menteeId: '',
            reassignLicenseFlag: 0,
            reassignLicenseOptions: [],
            reassign_license_duration: 0,
            orderItems: [],
            isModalVisible: false,
            selectedMentorId: '',
            selectedMentorName: '',
            multipleCompletedAssessment: [],
            isAddMentorModalVisible: false,
            isResendAssessmentModalVisible: false,
            multipleResendAssessment: [],
            success_message: '',
            dismissCountDown: 0,
            managerItems: [],           
            managerCount: '',
            see_more_managers_text: 'See more',
            show_more_managers: false,
            lessManagerItems: [],
            isProcessPaymentModalVisible: false,
        }
    },
    beforeCreate: function() {
      store.dispatch('active_tab', '');
   },
   methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    resendAssessmentFromModal: function(val) {
      axios('/desktop/manager/resend-mentor-assessment-token',
      {
        method: 'POST',
        params: {
          send_montor_assessment_id: val, 
        }
      })
      .then(resp => {
          this.success_message = 'Email Sent to Mentor successfully.';
          this.dismissCountDown = 5;    
          this.isResendAssessmentModalVisible = false;
      })
      .catch(() => {
      });
    },
    resendMentorAssessmentAction: function(item) {
      axios('/desktop/manager/resend-mentor-assessment-token',
      {
        method: 'POST',
        params: {
          send_montor_assessment_id: item.sendMentorAssessmentId, 
        }
      })
      .then(resp => {
          this.success_message = 'Email Sent to Mentor successfully.';
          this.dismissCountDown = 5;        
      })
      .catch(() => {
      });
    },
    openResendAssessmentModal: function(res) {
      this.multipleResendAssessment = res;
      this.isResendAssessmentModalVisible = true;
    },
    addMentorAction: function() {
      axios('/desktop/manager/activate-pending-mentor',
      {
        method: 'POST',
        params: {
          account_id: this.$store.state.user_accountid, 
          mentor_id: this.selectedMentorId, 
        }
      })
      .then(resp => {
        this.getPendingMentors();
        this.isAddMentorModalVisible = false;
      })
      .catch(() => {
      });
    },
    addMentor: function(item) {
      this.selectedMentorId = item.id;
      this.selectedMentorName = item.first_name + ' ' + item.last_name;
      this.isAddMentorModalVisible = true;
    },
    openViewAssessmentModal: function(mentorId) {
      this.selectedMentorId = mentorId;
      axios('/desktop/manager/mentor-completed-assessment-lists',
      {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          mentor_id: this.selectedMentorId, 
        }
      })
      .then(resp => {
        this.isModalVisible = true;
        this.multipleCompletedAssessment = resp.data.completedAssessments;
      })
      .catch(() => {
      });

      
    },
    viewMentorAssessmenteportModal: function(assessmentAttemptId) {
      this.isModalVisible = false;
      let route = this.$router.resolve({path: '/assessment-report/' + assessmentAttemptId});
      window.open(route.href, '_blank');
    },
    viewMentorAssessmenteport: function(assessmentAttemptId) {
      let route = this.$router.resolve({path: '/assessment-report/' + assessmentAttemptId});
      window.open(route.href, '_blank');
    },
    assignLicense: function(menteeId) {
      this.showOverlay = true;
      axios('/desktop/manager/check-account-license',
      {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          mentee_id: menteeId, 
        }
      })
      .then(resp => {
        this.showOverlay = false;
        this.hasLicense = resp.data.has_active_license;
        if(this.hasLicense == 0) {
          this.assignModalTitle = 'No License Avaliable';
        }
        this.license_expire_date = resp.data.account_license_expire_date;
        this.isAssignModalVisible = true;
        this.license_account_id = resp.data.account_license_id;
        this.menteeName = resp.data.mentee_name;
        this.menteeId = menteeId;
        this.reassignLicenseFlag = resp.data.reassign_license_flag;
        this.reassignLicenseOptions = resp.data.reassign_license_options;
        this.$refs.AssignModal.getReassignLicenseOptionsSelected(this.reassignLicenseOptions);
      })
      .catch(() => {
      });

    },
    renewLicense: function(menteeId) {
      this.showOverlay = true;
      axios('/desktop/manager/check-account-license',
      {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          mentee_id: menteeId, 
        }
      })
      .then(resp => {
        this.showOverlay = false;
        this.hasLicense = resp.data.has_active_license;
        if(this.hasLicense == 0) {
          this.assignModalTitle = 'No License Avaliable';
        }
        this.license_expire_date = resp.data.account_license_expire_date;
        this.license_account_id = resp.data.account_license_id;
        this.menteeName = resp.data.mentee_name;
        this.isRenewModalVisible = true;
        this.menteeId = menteeId;
        this.reassignLicenseFlag = resp.data.reassign_license_flag;
        this.reassignLicenseOptions = resp.data.reassign_license_options;
        this.$refs.RenewModal.getReassignLicenseOptionsSelected(this.reassignLicenseOptions);
      })
      .catch(() => {
      });

    },
    inactiveLicense: function(menteeId) {
      this.showOverlay = true;
      axios('/desktop/manager/check-account-license',
      {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          mentee_id: menteeId, 
        }
      })
      .then(resp => {
        this.showOverlay = false;
        this.menteeName = resp.data.mentee_name;
        this.isInactiveModalVisible = true;
        this.menteeId = menteeId;
        this.reassign_license_duration = resp.data.reassign_license_duration;
      })
      .catch(() => {
      });
    },
    formatAddress(city, state) {
      var address = '';
      if (city) {
          address += city + ", ";
      }
      if (state) {
          address += state + ", ";
      }
      return address.slice(0, -2);
    },
    initialAvatar(firstname, lastname) {
      var initial = '';
      initial = firstname.charAt(0) + lastname.charAt(0);
      return initial.toUpperCase();
    },
    getMenteeLicense: function() {
      axios('/desktop/manager/manage-license',
      {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        this.accountItems = resp.data;
        this.menteesApprentices = this.accountItems.menteesApprentices;
        
      })
      .catch(() => {
      });

    },

    getPendingMentors: function() {
      axios('/desktop/manager/pending-mentors',
      {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        this.pendingMentors = resp.data.pendingMentors;
        
      })
      .catch(() => {
      });

    },

    getOrderItems: function() {
      axios('/desktop/manager-orders/' + this.$store.state.user_accountid,
      {
        method: 'GET',
      })
      .then(resp => {
        this.orderItems = resp.data.orderItems;
        
      })
      .catch(() => {
      });

    },

    getInvoicePdf(item) {
      let pdfEndPoint;
      pdfEndPoint = '/getOrderInvoicePdf';
      axios(pdfEndPoint,
        {
          method: 'POST',
          data: {
              "billing": {
                  "billing_name": item.billingName,
                  "billing_address": item.address,
                  "billing_address2": item.address2,
                  "billing_city": item.city,
                  "billing_country": item.countryCode,
                  "billing_phone": item.phoneNumber,
                  "billing_state": item.stateCode,
                  "billing_zip": item.zipCode,
                  "billing_primary_admin": item.billingPrimaryAdmin
              },
              "orderId": item.orderId
          }
        },
      )
      .then(response => {
        window.open(response.data.invoice_filepath, '_blank');
      })
      .catch(error => {
        console.log(error)
      });
    },
    openAddLicenseModal() {
     this.isAddLicenseModalVisible = true;
     this.$refs.AddLicenseModal.loadInitialData();
    },
    openProcessPaymentModal(orderId) {
     this.isProcessPaymentModalVisible = true;
     this.$refs.ProcessPaymentModal.loadInitialData(orderId);
    },
    getMenteeProfileLink(id) {
      router.push('/view-mentee-profile/' + id);
    },
    getManagerList() {
      axios('/mobile/manager/my-account-lists',
      {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        this.managerCount = resp.data.manager.length;
        this.managerItems = resp.data.manager;
        
      })
      .catch(() => {
      });

    },

   },
   created() {
      var roles = store.state.roles;
      if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
        this.admin = true;
      }
      this.getMenteeLicense();
      this.getOrderItems();
      this.getPendingMentors();
      this.getManagerList();
      setTimeout(() => {
      if(this.$store.state.invoice_order_id > 0) {
        this.openProcessPaymentModal(this.$store.state.invoice_order_id);        this.$store.dispatch('invoice_due_order_id', '');
      }
      }, 1500);

   }, 

   components: {
    UserMenu,
    AssignLicense,
    InactiveLicense,
    RenewLicense,
    AddLicense,
    ProcessPayment,
    ViewMultipleCompletedAssessment,
    ActivateModal,
    ResendAssessment,
    Avatar,
    DbCardList,
   },
}
</script>

<style scoped>
.mentor-container {
  margin: 0px auto;
  width: 100%;
  padding-top: 0px;
}
.db-card {
  background-color: #FFF;
  width: 100%;
  min-height: 120px;
  padding: 10px;
  margin: 10px 0;
  border-radius: 10px;  
}
.db-card .title{
  font-size: 14px;
  font-weight: 900;
}
.db-card .empty-content-title{
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.db-card .acc-info {
  font-size: 13px;
  font-weight: 600;
  margin-left: 10px;
}
.db-card .db-report-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
.db-card .db-empty-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  text-align: center;
}
.dbViewBtn{
  color: #00acee;
  background-color: #FFF;
  border: 1px solid #00acee;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  width: 50px;
  float: right;
}
.dbViewBtn:focus, .dbViewBtn:hover {
  color: #00acee !important;
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
} 
/* media query css start */
@media (min-width: 992px) {
  .db-row {
    margin-left: 1rem;
  }
}
.question_text, .question_text a, .question_text a:hover {
  font-size: 11px;
  color: #7D7D7D;
}
.start-button {
    color: #00acee;
    background-color: #FFF;
    border: 1px solid #00acee;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 110px;
}
.begin-course-button {
    color: #fff;
    background-color: #00acee !important;
    border: 1px solid #00acee !important;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 110px; 
}
.view-certificate {
    text-align: right;
    padding: 10px 16px 3px 30px;
    font-size: 12px;
}
.view-certificate a, .view-certificate a:hover{ 
  color: #7D7D7D !important;
  text-decoration: none !important;
  font-weight: bold;
}
.circle {
  background-color: #A5A5A5;
  border-radius: 30px;
  text-align: center;
  width: 60px;
  height: 60px;
  margin-right: 5px;
  float: left;
}
.initials {
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  position: relative;
  transform: translateY(22px);
  color: #FFF;
  display: inline-block;
  vertical-align: middle;
}
.db-card .db-mentee-name {
  font-weight: 600;
  word-break: break-word;
  margin-top: 9px;
  margin-left: 60px;
  text-transform: capitalize;
}
.db-card .db-mentee-email {
  word-break: break-word;
  margin-top: 0px; 
  font-size: 13px;
  margin-left: 60px;
}
.license-count {
  font-size: 14px;
  margin: 1px 0px 15px 0px;
  padding-left: 10px;
}
.renew-flag {
  color: #00ACEE;
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  margin-top: 15px;
  text-align: center;
  cursor: pointer;
}
.red-text {
  color: #FF0000;
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  margin-top: 15px;
  text-align: center;
  flex: 0 0 23%;
}
.red-expire-text {
  color: #FF0000;
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  margin-top: 20px;
  text-align: center;
  flex: 0 0 23%;
}
.green-text {
  color: #008000;
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  margin-top: 15px;
  text-align: center;
  word-break: break-word;
  flex: 0 0 21%;
  padding-left: 25px;
}
.grey-text {
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  margin-top: 20px;
  text-align: center;
  flex: 0 0 23%;
}
.ma-blue-btn {
  color: #FFF !important; 
  border-radius: 10px;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 110px;
  padding: 4px;
}
.ma-white-btn {
  color: #00acee !important; 
  border-radius: 10px;
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 110px;
}
.receipt-heading {
  float: left;
  font-weight: bold;
  font-size: 14px;
  text-decoration: underline;
}
.receipt-heading-1, .receipt-heading-4 {
  width: 13%;
}
.receipt-heading-3,  .receipt-heading-6 {
  width: 15%; 
}
.receipt-heading-2, .receipt-heading-5 {
  width: 21%;
}
.receipt {
  font-weight: normal;
  text-decoration: none;
  float: left;
  font-size: 13px;
  padding-top: 8px;
}
.invoice_link { color: #00ACEE; }
.modal-header .sub-heading h3 {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}
.dbAddBtn, .dbAddBtn, .dbEditBtn{
  color: #00ACEE;
  border: 0px solid #29A3E4;
  background: none;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  text-decoration: underline !important;
  text-align: right;
}
.dbEditBtn {
  width: 50px;
  float: right;
  margin-top: 15px;
}
.dbAddBtn:active, .dbAddBtn:focus, .dbAddBtn:hover, .dbEditBtn:focus, .dbEditBtn:hover {
  color: #00acee !important;
  background:none !important;
  border: 0px solid #00acee !important;
  box-shadow: none !important;
} 
</style>



// WEBPACK FOOTER //
// src/components/manager/manage_license.vue